import {
  FillOrgWithDemoManufacturingDataRequest,
  FillOrgWithDemoManufacturingDataResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/workflows_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type FillOrgWithDemoManufacturingDataParams = {
  orgId: string;
  daysInPast: number;
};

export const fillOrgWithDemoManufacturingData = async (
  { orgId, daysInPast }: FillOrgWithDemoManufacturingDataParams,
  headers: Record<RequestMetadata, string>,
): Promise<FillOrgWithDemoManufacturingDataResponse> => {
  const req = new FillOrgWithDemoManufacturingDataRequest({
    orgId,
    daysInPast,
  });

  return supportServiceConnectClient.fillOrgWithDemoManufacturingData(req, {
    headers,
  });
};
